var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avatar",class:( _obj = {}, _obj['size-' + _vm.size] = true, _obj['has-image'] =  _vm.image, _obj.transparent = _vm.transparent, _obj['is-anonymised'] =  _vm.anonymised, _obj ),style:(_vm.style)},[_vm._v("\n  "+_vm._s(_vm.image ? '' : _vm.inicials)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }